import React from 'react';
import PropTypes from 'prop-types';


function getAddresses(arr){

        var addresses = arr.map((c, index) =>

            <span key={index}>
                Contact: {c.name} <br />
                {c.address} <br /> 
                {c.phone} <br /> 
                <a href={c.email}>{c.email}</a><br />
            </span>
        );

        return addresses;

}

function TWICLCompaniesSearchItem({ entry }) {


        var companyName = entry.companyName != null ? entry.companyName : "";

        var link = entry.certificate != null && entry.certificate.sys.uri != null ? entry.certificate.sys.uri : "";

        var certificate = entry.companyCertificate !=null && entry.companyCertificate.list != null ? entry.companyCertificate.list : "";

        var certificateHolder = entry.certificateHolder !=null ? getAddresses(entry.certificateHolder) : null;



    
        return (
            <div className="search-result">
            
                <div className="company">
                    <h4>{companyName}</h4>

                    <p>
                    Certification: <a href={link}><i className="fas fa-file-pdf company-certificate"></i>{certificate}</a> <br />

                    {certificateHolder}

                    </p>

                </div>
            </div>
        );
    
    
}


TWICLCompaniesSearchItem.propTypes = {
    entry: PropTypes.object
};

export default TWICLCompaniesSearchItem;